import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RoutePaths } from '@routes';
import { useAppDispatch } from '@store';
import { loadAppData } from '@store/initialisation';
import { userWelcomeRequiredSelector } from '@store/programme';

const useOnLoad = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const isWelcomeRequired = useSelector(userWelcomeRequiredSelector);

    useEffect(() => {
        dispatch(loadAppData());
    }, [dispatch]);

    useEffect(() => {
        if (isWelcomeRequired) {
            navigate(RoutePaths.WELCOME);
        }
    }, [isWelcomeRequired, navigate]);
};

export default useOnLoad;
